// extracted by mini-css-extract-plugin
export default {"reverseRow":"ImageTextSection_reverseRow__JgQmF","contentDiv":"ImageTextSection_contentDiv__4+PPd","isMobileReverse":"ImageTextSection_isMobileReverse__R5bb7"};